import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AcceptInviteComponent } from './accept-invite/accept-invite.component';
import { RegistrationComponent } from './company/registration.component';
import { QpRegistrationComponent } from './qp/qp-registration.component';
import { RegisterBusinessTypeComponent } from './register-business-type/register-business-type.component';
import { RegistrationGuard } from './registration-guard.service';
import { TermsComponent } from './terms/terms.component';
const routes: Routes = [
  {
    path: 'accept-invite',
    component: AcceptInviteComponent,
    canActivate: [MsalGuard, RegistrationGuard],
    data: { redirectUri: 'register/accept-invite', action: 'invite' }
  },
  {
    path: 'terms',
    component: TermsComponent,
    canActivate: [MsalGuard],
    data: { redirectUri: 'register/terms', action: 'terms' }
  },
  {
    path: 'choose/:type/:id',
    component: RegisterBusinessTypeComponent,
    canActivate: [MsalGuard, RegistrationGuard],
    data: { redirectUri: 'register/choose/company/new', action: 'register' }
  },
  {
    path: 'business-type/:type/:id',
    component: RegisterBusinessTypeComponent,
    canActivate: [MsalGuard],
    data: { redirectUri: 'register/choose/company/new', action: 'register' }
  },
  { path: 'company/:id', component: RegistrationComponent },
  { path: 'qp/:id', component: QpRegistrationComponent }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [RegistrationGuard]
})
export class RegistrationRoutingModule {}
